// sha256(lower(trim(value))) as hex
export async function sha256Hex(value: string | null | undefined): Promise<string | undefined> {
  // crypto.subtle is only available in secure contexts
  if (!value || !globalThis.crypto?.subtle) return undefined;
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(value.trim().toLowerCase()));
  return Array.from(new Uint8Array(digest), b => b.toString(16).padStart(2, '0')).join('');
}
